import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

/** Redirects unauthenticated /claim visits to login with claims-page context preserved. */
@Injectable()
export class ClaimLoginRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): UrlTree {
    return this.router.createUrlTree(['login'], { queryParams: { redirect: '/claim' } });
  }
}
